import { render } from "./ExpenseTxns.vue?vue&type=template&id=12937a41&scoped=true"
import script from "./ExpenseTxns.vue?vue&type=script&lang=js"
export * from "./ExpenseTxns.vue?vue&type=script&lang=js"

import "./ExpenseTxns.vue?vue&type=style&index=0&id=12937a41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12937a41"]])

export default __exports__